<template>
  <TeamMembersPanel
    v-model:selected-users="selected_users"
    v-model:deselected-users="deselected_users"
    :title="$t('Share') + ` ${page.name}`"
    @submit="sharePage"
    @cancel="$emit('cancel')" />
</template>

<script>
import TeamMembersPanel from "../shared/TeamMembersWithAccessPanel.vue"
export default {
  components: {
    TeamMembersPanel
  },
  inject: ["sharePageWithTeamMember"],
  props: {
    page: {
      type: Object,
      required: false
    }
  },
  emits: ["cancel", "submitted", "done"],
  data() {
    return {
      selected_users: [],
      deselected_users: []
    }
  },

  created() {
    this.selected_users = this.page.shared_with || []
  },

  methods: {
    sharePage() {
      this.sharePageWithTeamMember({ page: this.page, users: this.selected_users })

      if (this.selected_users.length == 0) {
        this.$toast.open({
          message: this.$t("Page") + ` ${this.page.name} ` + this.$t("is no longer shared"),
          position: "top",
          type: "success",
          duration: 3000
        })
      } else {
        this.$toast.open({
          message:
            this.$t("Page") + ` ${this.page.name} ` + this.$t("is shared with") + ` ${this.page.shared_with.length} ` + this.$t("user(s)"),
          position: "top",
          type: "success",
          duration: 3000
        })
      }
      this.$emit("done")
    }
  }
}
</script>
